<template>
    <div id="map">

    </div>
</template>

<script>
import { sharedMap, notify } from '@/mixins'
import { ICON_OPTIONS, ICONS, MARKER_TYPE } from '@/services/MappingService'

export default {
    name: 'MeterMap',
    mixins: [sharedMap, notify],
    mounted () {
        const drawingLayer = this.editableLayer
        const map = this.map
        this.map.on('draw:created', (event) => {
            const type = event.layerType
            const layer = event.layer
            const polygon = this.getClusterPolygon()
            this.removeExistingMarkers()

            if (polygon && !polygon.getBounds().contains(layer._latlng)) {
                const errorMessage = 'Please position the meter within the selected cluster boundaries.'
                this.$emit('locationSet', { error: errorMessage, geoDataItem: undefined })
                return
            }

            drawingLayer.addLayer(layer)
            this.$emit('locationSet', {
                error: undefined,
                geoDataItem: {
                    type: type,
                    coordinates: layer._latlng
                }
            })
        })
    },
    methods: {
        getClusterPolygon () {
            return this.editableLayer.getLayers().find((layer) => layer.feature && layer.feature.geometry.type === 'Polygon')
        },
        drawCluster () {
            this.editableLayer.clearLayers()
            const geoData = this.mappingService.geoData.geo_data
            const geoType = geoData.geojson.type
            const coordinatesClone = geoData.geojson.coordinates[0].reduce((acc, coord) => {
                acc[0].push([coord[1], coord[0]])
                return acc
            }, [[]])
            const drawing = {
                type: 'FeatureCollection',
                crs: {
                    type: 'name',
                    properties: {
                        name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
                    }
                },
                features: [{
                    type: 'Feature',
                    properties: {
                        popupContent: geoData.display_name,
                        draw_type: geoData.draw_type === undefined ? 'set' : geoData.draw_type,
                        selected: geoData.selected === undefined ? false : geoData.selected,
                        clusterId: geoData.clusterId === undefined ? -1 : geoData.clusterId,
                    },
                    geometry: {
                        type: geoType,
                        coordinates: geoData.searched ? geoData.geojson.coordinates : coordinatesClone
                    }
                }]
            }
            const polygonColor = this.mappingService.strToHex(geoData.display_name)
            const editableLayer = this.editableLayer
            const geoDataItems = this.geoDataItems
            const drawnCluster = L.geoJson(drawing, {
                style: { fillColor: polygonColor, color: polygonColor },
                onEachFeature: function (feature, layer) {
                    editableLayer.addLayer(layer)
                    geoDataItems.push({
                        leaflet_id: layer._leaflet_id,
                        type: 'manual',
                        geojson: {
                            type: geoData.geojson.type,
                            coordinates: geoData.searched === true ? coordinatesClone : geoData.geojson.coordinates
                        },
                        searched: false,
                        display_name: geoData.display_name,
                        selected: feature.properties.selected,
                        draw_type: feature.properties.draw_type,
                        lat: geoData.lat,
                        lon: geoData.lon,
                    })
                }
            })
            const bounds = drawnCluster.getBounds()
            this.map.fitBounds(bounds)
        },
        setMiniGridMarker () {
            this.mappingService.markingInfos.filter((markingInfo) => markingInfo.markerType === MARKER_TYPE.MINI_GRID).map((markingInfo) => {
                const miniGridMarkerIcon = L.icon({
                    ...ICON_OPTIONS,
                    iconUrl: ICONS[markingInfo.markerType]
                })
                const miniGridMarker = L.marker([markingInfo.lat, markingInfo.lon], { icon: miniGridMarkerIcon })
                miniGridMarker.bindTooltip('Mini Grid: ' + markingInfo.name)
                miniGridMarker.addTo(this.map)
            })
        },
        setMeterMarkerManually (location) {
            const polygon = this.getClusterPolygon()
            if (polygon && !polygon.getBounds().contains(location)) {
                const errorMessage = 'Please position the meter within the selected cluster boundaries.'
                this.$emit('locationSet', { error: errorMessage, geoDataItem: undefined })
                return
            }
            this.removeExistingMarkers()
            const meterMarkerIcon = L.icon({
                ...ICON_OPTIONS,
                iconUrl: ICONS.METER
            })
            const meterMarker = L.marker(location, { icon: meterMarkerIcon })
            meterMarker.addTo(this.editableLayer)
        },
        invalidateSize () {
            if (this.map) {
                this.map.invalidateSize()
            }
        }
    }
}
</script>

<style scoped>
#map {
    height: 100%;
    min-height: 420px;
    width: 100%;
}

.leaflet-draw-actions a {
    background: white !important;
}
</style>
